<div class="rules-section">
  <div class="flex flex-horiz-space-bw m-t-b-10">
    <nz-radio-group [(ngModel)]="rulesRadio" [nzButtonStyle]="'solid'"
                    (ngModelChange)="filterRules()">
      <label nz-radio-button nzValue="All">All</label>
      <label nz-radio-button nzValue="Failed">Failed</label>
      <label nz-radio-button nzValue="Passed">Passed</label>
    </nz-radio-group>
    <div class="f-s-1-3r p-r-5">
      <span  class="clickable" (click)="filterRules('All')">{{rulesData.length}} rules </span> &bull; <span class="col-red clickable" (click)="filterRules('Failed')">{{rulesFailedCount}} failed
             </span> &bull; <span class="col-green clickable" (click)="filterRules('Passed')">{{rulesPassedCount}} passed</span>
    </div>
  </div>

  <h3 class="heading d-b m-t-b-20"><i nz-icon nzType="profile"></i> Showing {{rulesRadio.toString().toLowerCase()}} rules ({{rulesDataFiltered.length}})</h3>

  <nz-skeleton [nzAvatar]="false" [nzActive]="true" [nzTitle]="true" [nzLoading]="rulesLoading">
    <nz-table [nzData]="[1,2,3]" [nzShowPagination]="false" [nzScroll]="{x:'1100px'}">
      <thead class="table-header">
      <tr>
        <th class="">Rule Name</th>
        <th class="">Rule Sub-type</th>
        <th class="">Decision Type</th>
        <th class="">Decision</th>
        <th class="">Decision Value</th>
        <th class="">Weight</th>
        <th class="">Recommendation</th>
      </tr>
      </thead>
      <tbody class="">
      <tr class="table-row" *ngFor="let rule of rulesDataFiltered">
        <td class="">{{rule.name}}</td>
        <td class="">{{rule.ruleSubType}}</td>
        <td class="">{{rule.decisionType}}</td>
        <td class="">{{rule.decision}}</td>
        <td class="">{{rule.decisionVal}}</td>
        <td class="">{{rule.weight}}</td>
        <td class="">{{rule.recco}}</td>
      </tr>
      </tbody>
    </nz-table>
  </nz-skeleton>
</div>
